import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Flame, X } from "lucide-react";
import { api } from "../lib/api";
import { ShareMomentForm } from "./RecoveryMoments";

export const MilestoneMomentPrompt = ({ onActive }) => {
  const [days, setDays] = useState(null);
  useEffect(() => { api.get("/me/moment-prompt").then(({ data }) => setDays(data.days)).catch(() => {}); }, []);
  useEffect(() => { onActive?.(!!days); }, [days, onActive]);
  if (!days) return null;
  const dismiss = () => { api.post(`/me/moment-prompt/${days}/done`).catch(() => {}); setDays(null); };
  return (
    <div className="relative card-surface p-6 mb-8 border-amber-400/40 bg-gradient-to-br from-amber-500/10 to-transparent" data-testid="milestone-moment-prompt">
      <button type="button" onClick={dismiss} aria-label="Not now" data-testid="milestone-prompt-dismiss"
        className="absolute top-4 right-4 p-1 rounded-full text-neutral-400 hover:text-white hover:bg-white/10"><X size={14} /></button>
      <div className="text-xs uppercase tracking-widest text-amber-300 mb-1 inline-flex items-center gap-2"><Flame size={13} /> {days}-day streak</div>
      <h3 className="font-display text-2xl text-neutral-100 mb-1" data-testid="milestone-prompt-title">You made it to day {days}.</h3>
      <p className="text-sm text-neutral-400 mb-4">That's worth marking. Want to share a moment from the road here? It could be what someone on day one needs to read.</p>
      <ShareMomentForm milestone={days} onDone={() => { toast.success(`Thank you for sharing your day ${days} moment.`); setDays(null); }} />
    </div>
  );
};
